export default __webpack_public_path__ + "assets/teamPhoto2025.bd1f91b4.JPG";